import EventBus from "./event-bus";

const axios = require('axios');

export function getMerchantAccount(merchantId) {
  return new Promise(function (resolve, reject) {
    console.log("updateOrder ")
    axios.get(process.env.ROOT_API + 'admin/account?merchantId='+merchantId, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("get Account Item");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        //reject()
        if(error.response != undefined && error.response.data != undefined && error.response.data.status != undefined && error.response.data.status == 403) {
          EventBus.$emit("sessionExpired");
        }
      });
  })
}

export function getMerchantAccounts(merchantId, from, to) {
  return new Promise(function (resolve, reject) {
    let url = process.env.ROOT_API + 'admin/accounts/query?merchantId='+merchantId + "&timeFrom=" + from + "&timeTo=" + to
    console.log("get Accounts " + url)
    axios.get(url, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      console.log("get Account Item");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        console.log("error to update");
        console.log(error.response);
        //reject()
        if(error.response != undefined && error.response.data != undefined && error.response.data.status != undefined && error.response.data.status == 403) {
          EventBus.$emit("sessionExpired");
        }
      });
  })
}

export function submitNewAccount(account) {
  return new Promise(function (resolve, reject) {
    let url = process.env.ROOT_API + 'admin/account';
    console.log("get Accounts " + url)
    EventBus.$emit("showLoading", true);
    axios.post(url, JSON.stringify(account), {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log("get Account Item");
      console.log(data);
      resolve(data);
    })
      .catch(error => {
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        //reject()
        if(error.response != undefined && error.response.data != undefined && error.response.data.status != undefined && error.response.data.status == 403) {
          EventBus.$emit("sessionExpired");
        }
      });
  })
}

export function deleteAccount(id) {
  return new Promise(function (resolve, reject) {
    console.log("delete account Record ")
    axios.delete(process.env.ROOT_API + 'admin/account?id='+id, {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function (response) {
      let data = response['data'];
      // console.log("get Account Item");
      // console.log(data);
      resolve(data);
    })
    .catch(error => {
      console.log("error to update");
      console.log(error.response);

      if(error.response != undefined && error.response.data != undefined && error.response.data.status != undefined && error.response.data.status == 403) {
        EventBus.$emit("sessionExpired");
      }
      reject(error);
    });
  })
}



// WEBPACK FOOTER //
// ./src/api/account.js